<div class="picview-dark-wrapper">
    <!-- Dark Themed Dialog -->
    <p-dialog [(visible)]="showPicDialog" [draggable]="false" (onHide)="closeDialogue()" [resizable]="false"
        [blockScroll]="true" [modal]="true" [closeOnEscape]="false" [maximizable]="false" styleClass="dark-pic-dialog"
        [width]="'90vw'" [height]="'90vh'">

        <!-- Header with Title and Close Button -->
        <ng-template pTemplate="header">
            <h5 class="pic-title" [title]="picData?.picTitle || 'Document View'">
                {{ picData?.picTitle || 'Document View' }}
            </h5>
            <div class="header-actions">
                <button class="copy-btn" (click)="copyDocumentUrl()" type="button" aria-label="Copy Document URL"
                    title="Copy Document URL" *ngIf="documentUrl || (picData?.contextId && (picData?.documentId || picData?.documentDumpId))">
                    <i class="fas fa-link"></i>
                </button>
                <button class="download-btn" (click)="downloadDocument()" type="button" aria-label="Download"
                    title="Download Document" *ngIf="picData?.documentName">
                    <i class="fas fa-download"></i>
                </button>
                <button class="close-btn" (click)="closeDialogue()" type="button" aria-label="Close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </ng-template>

        <!-- Body -->
        <div class="dark-pic-body">
            <!-- PDF Viewer -->
            <div class="pdf-container" *ngIf="fileCategory === 'pdf'">
                <iframe [src]="pdfUrl" type="application/pdf" class="pdf-viewer" frameborder="0"></iframe>
            </div>

            <!-- Video Viewer -->
            <div class="video-container" *ngIf="fileCategory === 'video'">
                <video [src]="videoUrl" class="main-video" controls style="width: 100%; max-height: 70vh;"></video>
            </div>

            <!-- Audio Viewer -->
            <div class="audio-container" *ngIf="fileCategory === 'audio'">
                <audio [src]="audioUrl" class="main-audio" controls style="width: 100%;"></audio>
            </div>

            <!-- Image Viewer -->
            <div class="image-container" *ngIf="fileCategory === 'image'">
                <!-- Main Image -->
                <div class="image-wrapper">
                    <img [src]="pics[currentPicIndex]" alt="Document" class="main-image">
                </div>
                <!-- Navigation Controls for Multiple Images -->
                <div class="image-controls" *ngIf="pics.length > 1">
                    <!-- Previous Button -->
                    <button class="nav-btn prev-btn" (click)="prevPic()" pButton type="button" icon="pi pi-chevron-left"
                        [text]="true" [rounded]="true" aria-label="Previous image">
                    </button>
                    <!-- Image Counter -->
                    <span class="image-counter">{{ getImageCounter() }}</span>
                    <!-- Next Button -->
                    <button class="nav-btn next-btn" (click)="nextPic()" pButton type="button"
                        icon="pi pi-chevron-right" [text]="true" [rounded]="true" aria-label="Next image">
                    </button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>